export default __webpack_public_path__ + "static/media/logo-inv.d480a6b3.png";